module.exports = __webpack_public_path__ + "img/fig09.50763223.jpg";